// =====================================================================
// SALÉSOL — Site Config
// Edit-friendly. Change strings here, push to GitHub, Cloudflare Pages
// auto-deploys in ~60 seconds. No build step required.
// =====================================================================

export const config = {
  // -----------------------------------------------------------------
  // EDITION STAMP — visible on the front cover top-right.
  // Update this every month (or whenever a new selection ships).
  // -----------------------------------------------------------------
  edition: {
    label: "SEPTEMBER-OCTOBER '26",
    sublabel: 'SELECTIONS',
  },

  // -----------------------------------------------------------------
  // BRAND COPY — strings that appear on covers and back page.
  // -----------------------------------------------------------------
  brand: {
    wordmark: 'salésol',
    // Front cover hero (each entry = one line):
    frontHero: ['Coffee,', 'treated as it', 'ought to be.'],
    // Back cover hero (each entry = one line):
    backHero: ['Roasted in', 'BSD City.'],
    coords: '06°18′S · 106°39′E',
    instagram: '@SALESOL.COFFEE',
    location: 'BSD CITY · SOUTH TANGERANG',
  },

  // -----------------------------------------------------------------
  // MODIFIERS — bottom-of-page modifier strips (price add-ons).
  // Reference these by key from menu.js.
  // -----------------------------------------------------------------
  modifiers: {
    espressoBlack: 'ICED +5',
    espressoMilk: 'ICED +5 · OAT/ALMOND +15',
    filter: 'ICED +5',
    foodMsgNote: '✦ HOUSE SIGNATURE  ·  ALL DISHES PREPARED WITH NO ADDED MSG',
  },

  // -----------------------------------------------------------------
  // BACK-COVER CTA — editorial invitation + pill button to the shop.
  // Set href: '' to hide the CTA entirely.
  // -----------------------------------------------------------------
  beansCta: {
    label: 'Take Salésol home,',
    ctaText: 'Shop beans',
    href: 'https://salesolcoffee.com',
  },

  // -----------------------------------------------------------------
  // SHARE / QR — what the share-sheet shows.
  // shareUrl is also encoded into the QR placeholder (real QR will be
  // generated from this once DNS points at Cloudflare Pages).
  // -----------------------------------------------------------------
  share: {
    title: 'Scan to open',
    url: 'menu.salesolcoffee.com',
  },

  // -----------------------------------------------------------------
  // SCENES MENU — chrome strings (EN / ID). Content strings live in the
  // data files and never change with the language switch.
  // -----------------------------------------------------------------
  ui: {
    en: { edition: 'September–October ’26 · Selections', order: 'We take your order at the table.', orderShort: 'ordered at the table', prices: 'prices in thousands of rupiah', scroll: 'scroll', touch: 'touch the surface', house: 'A house signature', foot: '◆ House signature · All dishes prepared with no added MSG', chapSig: 'I — Signatures', chapCoffee: 'II — Coffee', chapFood: 'III — Food', chapTea: 'IV — Tea', servedAs: 'Served as', service: 'Service', close: 'Close', turn: 'Drag to turn the globe', roasted: { pre: 'Roasted in ', it: 'BSD City.' }, home: 'Take Salésol home.', shop: 'Shop beans', coffeeH: { pre: 'Coffee, treated as it ', it: 'ought to be.' }, coffeeS: 'Fifteen lots this edition — espresso or filter. Varietal, process and roaster under every cup.', filterH: { pre: 'Filter, ', it: 'by hand.' }, filterOne: 'Brewed to order, over Paragon.', filterS: 'Brewed to order over Paragon. The first drops meet a chilled sphere — the aromatics that would leave with the steam stay in the cup.', threeWays: 'Three shelves', wayMicro: 'The microlots', wayMicroS: 'Indonesia and East Africa. COE finalists.', wayExp: 'The experimental exotics', wayExpS: 'Precision fermentation, Colombia.', wayEst: 'The exotic estates', wayEstS: 'The Geshas. Terroir as protagonist.', foodH: { pre: 'Cooked with ', it: 'discipline.', post: ' Served with warmth.' }, foodS: 'Fresh pasta, rice, Neapolitan pizza, plated dessert. Nothing with added MSG.', tapLot: 'Tap any lot for its origin and notes', tapDish: 'Tap a plate to jump to it', msg: 'All dishes prepared with no added MSG.', tabs: { sig: 'Signatures', esp: 'Espresso', filter: 'Filter', kitchen: 'Kitchen', dessert: 'Dessert', bakery: 'Bakery', tea: 'Tea' }, r: { esp: 'Espresso', filter: 'Filter', kitchen: 'Kitchen', dessert: 'Dessert', bakery: 'Bakery', tea: 'Tea' } },
    id: { edition: 'September–Oktober ’26 · Pilihan', order: 'Kami catat pesanan Anda di meja.', orderShort: 'dipesan di meja', prices: 'harga dalam ribuan rupiah', scroll: 'scroll', touch: 'sentuh permukaannya', house: 'House signature', foot: '◆ House signature · Semua hidangan tanpa tambahan MSG', chapSig: 'I — Signatures', chapCoffee: 'II — Coffee', chapFood: 'III — Food', chapTea: 'IV — Tea', servedAs: 'Disajikan sebagai', service: 'Pilihan', close: 'Tutup', turn: 'Geser untuk memutar globe', roasted: { pre: 'Roasted in ', it: 'BSD City.' }, home: 'Bawa Salésol pulang.', shop: 'Beli beans', coffeeH: { pre: 'Kopi, diperlakukan ', it: 'semestinya.' }, coffeeS: 'Lima belas lot edisi ini — espresso atau filter. Varietal, proses dan roaster tercantum di setiap cangkir.', filterH: { pre: 'Filter, ', it: 'dengan tangan.' }, filterOne: 'Diseduh saat dipesan, di atas Paragon.', filterS: 'Diseduh saat dipesan di atas Paragon. Tetesan pertama jatuh ke bola dingin — aroma yang biasanya hilang bersama uap tetap tinggal di cangkir.', threeWays: 'Tiga rak', wayMicro: 'The microlots', wayMicroS: 'Indonesia dan Afrika Timur. Finalis COE.', wayExp: 'The experimental exotics', wayExpS: 'Fermentasi presisi, Kolombia.', wayEst: 'The exotic estates', wayEstS: 'Para Gesha. Terroir yang bicara.', foodH: { pre: 'Dimasak dengan ', it: 'disiplin.', post: ' Disajikan dengan hangat.' }, foodS: 'Pasta segar, nasi, pizza Neapolitan, dessert. Tanpa tambahan MSG.', tapLot: 'Ketuk lot mana pun untuk melihat asal dan catatannya', tapDish: 'Ketuk piring untuk langsung ke halamannya', msg: 'Semua hidangan tanpa tambahan MSG.', tabs: { sig: 'Signatures', esp: 'Espresso', filter: 'Filter', kitchen: 'Kitchen', dessert: 'Dessert', bakery: 'Bakery', tea: 'Tea' }, r: { esp: 'Espresso', filter: 'Filter', kitchen: 'Kitchen', dessert: 'Dessert', bakery: 'Bakery', tea: 'Tea' } },
  },

  // Roasters for the origin globe: the arc runs farm → roaster.
  roasters: {
    bsd: { city: '', ll: [-6.3, 106.65] },
    mel: { city: 'ST. ALi, Melbourne', ll: [-37.81, 144.96] },
    syd: { city: 'ONA, Sydney', ll: [-33.87, 151.21] },
  },

  // Chapter II opener: the Blender bean pour. Ship one or the other, never both.
  //   beans: { video: '/illustrations/beans.mp4', poster: '/illustrations/beans-poster.jpg' }
  //   or   { frames: { dir: '/illustrations/beans/', count: 72, ext: 'webp' } }  // scrubbed by scroll
  // Leave null and the opener renders flat: night panel and copy only,
  // no bean footage. (The three.js bean field it used to fall back to was cut
  // from the spec in the September revision.)
  beans: { video: '/illustrations/beans.mp4', poster: '/illustrations/beans-poster.jpg' },

  // -----------------------------------------------------------------
  // ATMOSPHERE — gold-dust particle layer in the dark frame.
  // Set enabled: false to remove particles entirely.
  // count: 30 (whisper) → 120 (busier). 60 = restrained default.
  // -----------------------------------------------------------------
  particles: {
    enabled: true,
    count: 60,
    color: 0xe0b97a, // rust-accent
  },

  // -----------------------------------------------------------------
  // AUDIO — synthesized paper-rustle on page turn (Web Audio API).
  // Customers can mute via the speaker icon top-right.
  // -----------------------------------------------------------------
  audio: {
    startMuted: false,
  },
};
